import { SVGAttributes } from 'react'

export const Office = (props: SVGAttributes<SVGElement>) => (
  <svg {...props} viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.25 22.4002V14.9335C23.25 14.7402 23.4067 14.5835 23.6 14.5835H34.5667C34.76 14.5835 34.9167 14.7402 34.9167 14.9335V22.4002C34.9167 22.5935 34.76 22.7502 34.5667 22.7502H23.6C23.4067 22.7502 23.25 22.5935 23.25 22.4002Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="29.1042"
      y1="23.5"
      x2="29.1042"
      y2="24.9167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="31.25"
      y1="25.4446"
      x2="26.9167"
      y2="25.4446"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11 38.58V29.62C11 29.388 11.188 29.2 11.42 29.2H24.58C24.812 29.2 25 29.388 25 29.62V38.58C25 38.8119 24.812 39 24.58 39H11.42C11.188 39 11 38.8119 11 38.58Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line x1="17.875" y1="39.75" x2="17.875" y2="41.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line
      x1="20.75"
      y1="42.0833"
      x2="15.25"
      y2="42.0833"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M33.1667 38.58V29.62C33.1667 29.388 33.3548 29.2 33.5867 29.2H46.7467C46.9787 29.2 47.1667 29.388 47.1667 29.62V38.58C47.1667 38.8119 46.9787 39 46.7467 39H33.5867C33.3548 39 33.1667 38.8119 33.1667 38.58Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="40.0417"
      y1="39.75"
      x2="40.0417"
      y2="41.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="42.9167"
      y1="42.0833"
      x2="37.4167"
      y2="42.0833"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="1.25"
      y1="43.5835"
      x2="55.75"
      y2="43.5835"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
